module.exports = __webpack_public_path__ + "static/media/ic_proyectos_communication_pin.12e1d50d.svg";